/** 403, rendered in place. A redirect to sign-in would make the user think their session died. */

import { useNavigate } from 'react-router';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export function ForbiddenPage({ required = [] }: { required?: readonly string[] }) {
  const navigate = useNavigate();

  return (
    <Stack spacing={2} sx={{ py: 8, textAlign: 'center', alignItems: 'center' }}>
      <Typography variant="h6" sx={{ fontWeight: 700 }}>
        You do not have access to this
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: '44ch' }}>
        Your role does not include this screen. Ask the owner to add it if you need it — you are
        still signed in.
      </Typography>

      {required.length > 0 && (
        <Typography variant="caption" color="text.secondary" sx={{ fontFamily: 'var(--pos-font-mono)' }}>
          Needs: {required.join(', ')}
        </Typography>
      )}

      <Button variant="outlined" onClick={() => void navigate('/')}>
        Back to the dashboard
      </Button>
    </Stack>
  );
}
